import axios from 'axios';
import React, { Component, createRef } from 'react';

class Contact extends Component {
    constructor(props){
        super(props);
        this.state = { 
            fullname: '',
            email: '',
            message: '',
            error: null
        };

        this.contactRef = createRef();
		this.titleRef = createRef();

		this.state = {
			width: 0,  // will be set on mount dynamically
			height: 0,
		};

		this.baseWidth = 0;  
  		this.baseHeight = 0;

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.bringToFront = this.bringToFront.bind(this);
        this.closeApp = this.closeApp.bind(this);
    }

    componentDidMount() {
		const dragTarget = this.contactRef.current; 
		const dragHandle = this.titleRef.current;
		const resizeHandle = dragTarget.querySelector('.resize-handle');
		
		// Measure initial size in pixels from actual DOM element
		const rect = dragTarget.getBoundingClientRect();
		
		this.baseWidth = rect.width;
  		this.baseHeight = rect.height;

		this.setState({
			width: rect.width,
			height: rect.height,
		});

		let isDragging = false;
		let isResizing = false;
		let startX = 0;
		let startY = 0;
		let initialLeft = 0;
		let initialTop = 0;
		let startWidth = 0;
		const DRAG_THRESHOLD = 5;

		// --- Drag logic ---
		const onMouseDown = (e) => {
			startX = e.clientX;
			startY = e.clientY;

			// Save the initial position of the window
			initialLeft = dragTarget.offsetLeft;
			initialTop = dragTarget.offsetTop;

			document.addEventListener('mousemove', onMouseMove);
			document.addEventListener('mouseup', onMouseUp);
		};

		const onMouseMove = (e) => {
			const dx = e.clientX - startX;
			const dy = e.clientY - startY;

			// Only start dragging after threshold
			if (!isDragging && (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD)) {
				isDragging = true;
			}

			if (!isDragging) return;

			// Update the window's position based on mouse movement delta
			dragTarget.style.left = `${initialLeft + dx}px`;
			dragTarget.style.top = `${initialTop + dy}px`;
		};

		const onMouseUp = () => {
			isDragging = false;
			document.removeEventListener('mousemove', onMouseMove);
			document.removeEventListener('mouseup', onMouseUp);
		};

		dragHandle.addEventListener('mousedown', onMouseDown);

		// --- Resize logic ---
		const onResizeMouseDown = (e) => {
			isResizing = true;
			startX = e.clientX;
			startY = e.clientY;
			startWidth = dragTarget.offsetWidth;

			document.addEventListener('mousemove', onResizeMouseMove);
			document.addEventListener('mouseup', onResizeMouseUp);

			e.preventDefault();
		};

		const aspectRatio = this.baseWidth / this.baseHeight;

		const MIN_WIDTH = 200;
		const MIN_HEIGHT = 250;
		const MAX_WIDTH = 400;
		const MAX_HEIGHT = 450;

		const onResizeMouseMove = (e) => {
			if (!isResizing) return;

			const deltaX = e.clientX - startX;
			const deltaY = e.clientY - startY;

			// Pick the dominant delta (horizontal or vertical)
			const delta = Math.abs(deltaX) > Math.abs(deltaY) ? deltaX : deltaY;

			let newWidth = startWidth + delta;
			let newHeight = newWidth / aspectRatio;

			// Clamp width and height to both min and max
			newWidth = Math.max(MIN_WIDTH, Math.min(MAX_WIDTH, newWidth));
			newHeight = Math.max(MIN_HEIGHT, Math.min(MAX_HEIGHT, newHeight));

			this.setState({
				width: newWidth,
				height: newHeight,
			});
		};

		const onResizeMouseUp = () => {
			isResizing = false;
			document.removeEventListener('mousemove', onResizeMouseMove);
			document.removeEventListener('mouseup', onResizeMouseUp);
		};

		resizeHandle.addEventListener('mousedown', onResizeMouseDown);
	}

    handleFormSubmit(event, state) {
        event.preventDefault();
        axios({
            method: 'post',
            url: 'https://formspree.io/f/xlevqlqo',
            data: this.state
        })
        .then(result => {
            this.resetForm();
        })
        .catch(error => this.setState({ error: error.message }));
    }

    resetForm(){
        document.getElementById('thankYouDiv').style.display = 'block';
        this.setState({fullname: '', email: '', message: ''});
    }

    bringToFront() {
        document.getElementById('cmdApp').style.zIndex = 1;
		document.getElementById('streamPageApp').style.zIndex = 1;
		document.getElementById('storePageApp').style.zIndex = 1;
		document.getElementById('aboutPageApp').style.zIndex = 1;
		document.getElementById('contactPageApp').style.zIndex = 2;
		document.getElementById('clipApp1').style.zIndex = 1;
		document.getElementById('clipApp2').style.zIndex = 1;
	}

    closeApp() {
        document.getElementById('contactPageApp').style.zIndex = 1;
        document.getElementById('contactPageApp').style.visibility = 'hidden';
    }

    closeThankYou() {
        document.getElementById('thankYouDiv').style.display = 'none';
    }

    render() { 
        const { width, height } = this.state;

		const baseWidth = this.baseWidth || 300;
        const baseHeight = this.baseHeight || 350;

		const scaleX = width / baseWidth;
		const scaleY = height / baseHeight;
		const scale = Math.min(scaleX, scaleY);

		const style = {
			overflow: 'hidden',
			...(this.state.width && this.state.height
				? { width: this.state.width, height: this.state.height }
				: {}) // fallback to CSS % sizing
		};

        return (
            <div 
                id='contactPageApp' 
                ref={this.contactRef}
				className="appWindow"
                onClick={this.bringToFront}
                style={style}
            >
                <div 
                    id="cmdtitlearea"
                    ref={this.titleRef}
                >
					<div id="contactPage-title"> 
						<b> Contact Form </b>
					</div>
                    <div className='closeButton' onClick={this.closeApp}>X</div>    
				</div>
                <div 
					id="cmdContentWrapper"
					style={{
					transform: `scale(${scale})`,
					transformOrigin: 'top left',
					width: baseWidth,
					height: baseHeight,
					position: 'relative',
					}}
				>
                    <div id="contactForm">
                        <form  onSubmit={e => {this.handleFormSubmit(e, this.state)}}>
                            <input type="text" id="fullname" name="fullname" placeholder="Your full name..." 
                            value={this.state.fullname} onChange={e => this.setState({fullname: e.target.value})}/>
                                
                            <input type="email" id="email" name="email" placeholder="Your email address..." 
                            value={this.state.email} onChange={e => this.setState({email: e.target.value})}/>
                                
                            <textarea id="message" name="message" placeholder="Message goes here..." 
                            value={this.state.message} onChange={e => this.setState({message: e.target.value})}></textarea>
                                
                            <button type="submit" id="submit">Submit</button>
                        </form>
                    </div>
                    <div id="thankYouDiv">
                        <div id="thankYouDivTitle"> 
                            <div className='closeButton' onClick={this.closeThankYou}>X</div>
                        </div>
                        <div id="thankYouMessage">
                            Thank You! <br />
                            Your message has been sent.
                        </div> 
                    </div>
                </div>
                <div className="resize-handle" />
            </div>
        );
    }
}
 
export default Contact;